import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  BaseApiTemplateService,
  Core2Config,
  ApiVisa,
  ApiResponseModel
} from '../../shared';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class BranchIntercompanySettingService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'intercompany/intercompany-branch-settings/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'intercompany/intercompany-branch-settings/backoffice-ep';
    this.httpClient = http;
  }
  
  public copyCompSettings(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "intercompany/intercompany-branch-settings/copy-comp-settings/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      payload,
      this.getHttpHeader(visa)
    );
  }
  
  
}
